import React from "react";
import "../../constants/styles/faq.scss";
import image1 from "../../constants/images/1.png";
import image2 from "../../constants/images/2.png";
import image3 from "../../constants/images/3.png";
import image4 from "../../constants/images/4.png";

function FAQ() {
    const contactData = [
        {
            name: "Brenna Li",
            phone: "+1 604 505 2505",
            email: "brenna@gmail.com",
            website: "https://br  nnal.github.io/",
            img: image1,
        },
        {
            name: "Anna Kirik",
            phone: "+1 437 971 3599",
            email: "anna.v.kirik@gmail.com",
            website: "https://ca.linkedin.com/in/anna-kirika",
            img: image2,
        },
        {
            name: "Jiaqi Guo",
            phone: "+1 647 616 0081",
            email: "guojiaqi2000@gmail.com",
            website: "https://www.linkedin.com/in/jiaqi-guo-6b040422b/",
            img: image3,
        },
        {
            name: "Liam Bakar",
            phone: "+1 408 717 2177",
            email: "bakar.liam.20@gmail.com",
            website: "https://www.linkedin.com/in/liam-bakar",
            img: image4,
        },
    ];

    return (
        <div className='FAQ'>
            {contactData.map((faq, index) => (
                <div key={index} className='Panel'>
                    <div className='ProfileCircle'>
                        <img src={faq.img} alt={faq.name} />
                    </div>
                    <div className='Info'>
                        <h2>{faq.name}</h2>
                        <p>Phone: {faq.phone}</p>
                        <p>Website: {faq.website}</p>
                        <p>Email: {faq.email}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default FAQ;
